import { render, staticRenderFns } from "./Politic.vue?vue&type=template&id=81220a96"
var script = {}
import style0 from "./Politic.vue?vue&type=style&index=0&id=81220a96&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports